import { useMutation } from "@tanstack/react-query";
import { useContext } from "react";

import { SimpleSnackbarContext } from "../components/SimpleSnackbar";
import { language } from "../language";
import { customFetch } from "../util/customFetch";
import SendMessage from "../util/message";

export function useProcessDefinitionDeploy() {
  const { actions: snackActions } = useContext(SimpleSnackbarContext);
  return useMutation({
    mutationFn: async ({
      file,
      filename,
      formsKeys,
      foldersIds,
      templatesIds,
    }) => {
      const body = new FormData();
      const blob = new Blob([file], { type: "text/xml" });
      body.append("data", blob, filename);

      const tenant = sessionStorage.getItem("tenant");
      tenant && body.append("tenant-id", tenant);

      body.append("deployment-name", filename.replace(/.bpmn$/, ""));
      body.append("documents", foldersIds);
      body.append("forms", formsKeys);
      body.append("templates", templatesIds);

      return await customFetch(`/api/smartbpm/deployments`, {
        method: "POST",
        body,
      });
    },
    onSuccess: () => {
      snackActions.open(language.pulishSucess, {
        severity: "success",
        duration: 3000,
        onClose: () => {
          SendMessage({ status: "success-publish" });
        },
      });
    },
    onError: (error) => {
      snackActions.open(error.message, { severity: "error", duration: 3000 });
    },
  });
}
